module.exports = __webpack_public_path__ + "static/garantia01-6817baaf349fbdf323e7da5aa2bb9328.jpg";